window.addEventListener("DOMContentLoaded", () => {
    const duration = 1200;
    const scrollToTarget = function (target, offset) {
        const top = target.getBoundingClientRect().top - offset;
        const startPos = window.pageYOffset;
        const diff = top;

        let startTime = null;
        let requestId;

        const loop = function (currentTime) {
            if (!startTime) {
                startTime = currentTime;
            }

            // Elapsed time in miliseconds
            const time = currentTime - startTime;

            const percent = Math.min(time / duration, 1);
            window.scrollTo(0, startPos + diff * percent);

            if (time < duration) {
                // Continue moving
                requestId = window.requestAnimationFrame(loop);
            } else {
                window.cancelAnimationFrame(requestId);
            }
        };
        requestId = window.requestAnimationFrame(loop);
    };

    const anchorMenu = document.querySelector(".section-anchor-menu");

    anchorMenu.querySelectorAll("span").forEach((menu) => {
        menu.addEventListener("click", function () {
            let id = menu.getAttribute("data-id");
            let element = document.getElementById(id);
            if (element) {
                let extraOffset =
                    document.querySelector("sticky-header").offsetHeight +
                    anchorMenu.offsetHeight -
                    2;

                if (
                    document.body.classList.contains("announce-top") &&
                    !document.body.classList.contains(
                        "shopify-section-header-sticky"
                    )
                ) {
                    extraOffset += document.querySelector(
                        ".announcement-bar.top"
                    ).offsetHeight;
                }

                scrollToTarget(element, extraOffset);
            }
        });
    });
});
